import styled from "styled-components";
import { COLOR_WHITE } from "../constants/colors";
import { SOCIAL_MEDIAS } from "../constants/socialMedias";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
`;

const SocialMedia = styled.a`
  display: flex;
  width: 34px;
  height: 34px;
  background-color: ${COLOR_WHITE};
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: lightgray;
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
`;

const ImgSocialMedia = styled.img`
  height: 20px;
  margin: auto;

  @media (max-width: 768px) {
    height: 18px;
  }
`;

function SocialMedias() {
  return (
    <Container>
      {SOCIAL_MEDIAS.map((socialMedia) => (
        <SocialMedia href={socialMedia.url} target="_blank" key={socialMedia.url}>
          <ImgSocialMedia src={socialMedia.icon} alt={socialMedia.name} />
        </SocialMedia>
      ))}
    </Container>
  );
}

export default SocialMedias;
